module.exports = __webpack_public_path__ + "img/bisc_logo.1c0cba8a.png";